/*
 * Copyright (c) 2023. Haodong JU
 */

import GlobalSettings, { getRootUrl } from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false,
    header: false
  },
  photo: {
    displayName: 'image',
    type: IKDataEntity.Types.Image,
    formConfig: {
      type: {
        root: () => getRootUrl() + GlobalSettings.servantRoot
      },
      requiredEdit: false,
      requiredNew: false,
      md: 12
    },
    header: false
  },
  name: {
    displayName: 'staff'
  },
  password: {
    formConfig: {
      rule: [
        v => /^[0-9]*$/.test(v) || this.$t('passwordOnlyNumbers')
      ],
      unique: true,
      extraUniqueCheckFunc: (val, list) => {
        return !list.some(it => val.startsWith(it))
      }
    }
  },
  hourlyWage: {
    displayName: 'ShiftHourlyRate'
  },
  permission: {
    displayName: 'bossPermission',
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    },
    form: true
  },
  isPartTime: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    },
    form: false
  },
  checkFiles: {
    displayName: 'DOCount',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  secretKey: {
    displayName: 'fingerKey',
    type: IKDataEntity.Types.String,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  rawAuth: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: [
          { id: 1, name: 'OpenTable' },
          { id: 2, name: 'OpenTakeaway' },
          { id: 3, name: 'EnterOthersTable' },
          { id: 4, name: 'CheckOut' },
          { id: 5, name: 'CheckOutForOthers' },
          { id: 6, name: 'ReturnDishes' },
          { id: 7, name: 'TransferTable' },
          { id: 8, name: 'TransferDishToOthers' },
          { id: 9, name: 'DishTransferTable' },
          { id: 10, name: 'MergeTable' },
          { id: 11, name: 'MergeToOthers' },
          { id: 12, name: 'UseDiscount' }
        ],
        itemText: 'name',
        itemValue: 'name',
        multiple: true
      }
    },
    header: false
  }
}
const config = {
  add: function (item) {
    item.isPartTime = 1
    item.secretKey = item.secretKey ? item.secretKey : ''
    return hillo.postWithUploadFile('Servant.php?op=add', item, {
      showLoading: true
    })
  },
  edit: function (item) {
    if (item.file) {
      item.imageExt = item.file.name.split('.').lastItem
    }
    item.secretKey = item.secretKey ? item.secretKey : ''
    return hillo.postWithUploadFile('Servant.php?op=update', item)
  },
  remove: function (id) {
    return hillo.post('Servant.php?op=delete', { id })
  },
  load: async function (filter) {
    const res = (await hillo.get('Servant.php', { lang: GlobalSettings.getLang(), ...filter }))
      .content
    res.forEach(it => {
      const realPower = it.rawAuth.split(',').filter(x => thisPowerList.includes(x))
      it.rawAuth = realPower.join()
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function uploadServantFiles (id, file, metadata) {
  return (await hillo.postWithUploadFile('Servant.php?op=addAttachment', {
    servantId: id,
    file,
    metadata: JSON.stringify(metadata)
  }))
}
export async function deleteServantFiles (attachmentId) {
  return (await hillo.post('Servant.php?op=removeAttachment', {
    attachmentId
  }))
}

export const thisPowerList = [
  'OpenTable',
  'OpenTakeaway',
  'EnterOthersTable',
  'CheckOut',
  'CheckOutForOthers',
  'ReturnDishes',
  'TransferTable',
  'TransferDishToOthers',
  'DishTransferTable',
  'MergeTable',
  'MergeToOthers',
  'UseDiscount'
]
